// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    production: false,
    googleApiKey: 'AIzaSyD-yeKEy4-WtjhufrwUOMh-kPp1QyIhals',
    estatedAPIKey: '8a90617c23663763749b6151b6fd5bb4',
    stripePublishableKey: 'pk_test_51IHZX0HQEZvFrXUmfScVtpvCV0zGn9zP6lqvFU9aZBFOy1ckYGeXseLBxbkWQmB3rAkkrK1TCcgZCYGaR0V2oASc00OXnlGZ3h',
    pricingTableId: 'prctbl_1O5nZXHQEZvFrXUmcIItBL1T',
    stripeCustomerPortal: 'https://billing.stripe.com/p/login/test_eVabLndPRfO1epW5kk',
    mailchimpClientId: '453227221989',
    constantContactClientId: '0aba1c4c-f337-45d0-854e-46814ae0f4d8'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
